import React from "react";
import { Chip, Stack, Tab, Tabs } from "@mui/material";
import { FilterType, filterLabels, JobCounts } from "../types";

interface Props {
  activeFilter: FilterType;
  jobCounts: JobCounts;
  onChange: (filter: FilterType) => void;
}

export const JobFilterTabs: React.FC<Props> = ({ activeFilter, jobCounts, onChange }) => (
  <Tabs
    value={activeFilter}
    onChange={(_, v) => onChange(v)}
    variant="fullWidth"
    sx={{
      px: 0,
      minHeight: 48,
      "& .MuiTab-root": {
        minHeight: 48,
        minWidth: 0,
        textTransform: "none",
        fontSize: "0.7rem",
        py: 1.5,
        px: 0.25,
        borderRadius: 1,
        transition: "background-color 0.2s ease",
        "&:focus": { outline: "none" },
        "&.Mui-focusVisible": { backgroundColor: "rgba(0, 0, 0, 0.04)" },
        "&.Mui-selected": { backgroundColor: "rgba(38, 41, 59, 0.08)", fontWeight: 600 },
        "&:hover:not(.Mui-selected)": { backgroundColor: "rgba(0, 0, 0, 0.04)" },
      },
    }}
  >
    {(Object.keys(filterLabels) as FilterType[]).map((filter) => (
      <Tab
        key={filter}
        value={filter}
        label={
          <Stack direction="row" spacing={0.25} alignItems="center">
            <span>{filterLabels[filter]}</span>
            {jobCounts[filter] > 0 && (
              <Chip
                label={jobCounts[filter]}
                size="small"
                sx={{ height: 16, fontSize: "0.6rem", "& .MuiChip-label": { px: 0.4 } }}
              />
            )}
          </Stack>
        }
      />
    ))}
  </Tabs>
);
